import type { SubAccount } from '../types';

/**
 * Sorts sub accounts by DisplayName (fallback to Name), then Name for stability.
 * Use when displaying sub account lists for consistent alphabetical ordering.
 */
export function sortSubAccountsByDisplayName<T extends Pick<SubAccount, 'Name'> & { DisplayName?: string | null }>(
  subAccounts: T[]
): T[] {
  return [...subAccounts].toSorted((a, b) => {
    const labelA = a.DisplayName ?? a.Name;
    const labelB = b.DisplayName ?? b.Name;
    const cmp = labelA.localeCompare(labelB);
    return cmp !== 0 ? cmp : a.Name.localeCompare(b.Name);
  });
}
